import { SignUpButton } from "@clerk/react";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Typography } from "@mui/material";
import { type FC } from "react";

import { useAuthRedirectUrl } from "~/feature/auth/hooks/useAuthRedirectUrl";
import { useSignUpUnsafeMetadata } from "~/feature/auth/hooks/useSignUpUnsafeMetadata";

import * as Styled from "./AppSignUpIconButton.styles";

interface ISignUpIconButtonProps {
  withCaption?: boolean;
}

export const AppSignUpIconButton: FC<ISignUpIconButtonProps> = ({
  withCaption = false,
}) => {
  const unsafeMetadata = useSignUpUnsafeMetadata();
  const redirectUrl = useAuthRedirectUrl();

  return (
    <SignUpButton
      mode="modal"
      forceRedirectUrl={redirectUrl}
      unsafeMetadata={unsafeMetadata}
    >
      <Styled.AppSignUpIconButton size="medium">
        <AccountCircleOutlinedIcon />
        {withCaption && (
          <Typography variant="caption" sx={{
            fontSize: 12
          }}>
            Sign up
          </Typography>
        )}
      </Styled.AppSignUpIconButton>
    </SignUpButton>
  );
};
